export const SET_BUSINESS_FILE = "SET_BUSINESS_FILE";
export const SET_BUSINESS_FILES = "SET_BUSINESS_FILES";
export const ADD_BUSINESS_FILE = "ADD_BUSINESS_FILE";
export const UPDATE_BUSINESS_FILE = "UPDATE_BUSINESS_FILE";
export const DELETE_BUSINESS_FILE = "DELETE_BUSINESS_FILE";
